import { gql } from "@apollo/client";
import {
  PodcastBaseFragment,
  PodcastDetailFragment,
  PodcastDefaultContentTemplateFragment,
} from "../../fragments/podcast";

export const QUERY_FETCH_PODCAST_LIST_PAGE = gql`
  query podcastListPage {
    podcastListPage {
      pageTitle
      heroTitle
      heroDescription
      heroImage {
        url
        alternativeText
      }
      latestTitle
      moreButtonTitle
      listenAtLabel
      platforms {
        url
        platform {
          name
          icon {
            url
            alternativeText
          }
        }
      }
      card {
        watchButtonLabel
        watchAgainButtonLabel
      }
    }
  }
`;

export const QUERY_FETCH_PODCAST_DETAIL_PAGE = gql`
  query podcastDetailPage {
    podcastDetailPage {
      backLinkLabel
      viewAllLabel
    }
  }
`;

export const QUERY_FETCH_PODCASTS = gql`
  query fetchPodcasts($page: Int!, $pageSize: Int, $userDocumentId: ID!) {
    podcasts: podcasts_connection(
      pagination: { page: $page, pageSize: $pageSize }
      sort: "publicationDate:desc"
      filters: { publishedAt: { notNull: true } }
    ) {
      nodes {
        ...PodcastBaseFragment
        listenings(
          filters: { staff: { documentId: { eq: $userDocumentId } } }
        ) {
          documentId
          listeningTime
          duration
        }
      }
      pageInfo {
        page
        pageCount
        total
        pageSize
      }
    }
  }
  ${PodcastBaseFragment}
`;

export const QUERY_FETCH_SEARCH_PODCASTS = gql`
  query fetchSearchPodcasts(
    $filters: PodcastFiltersInput
    $pagination: PaginationArg
    $userDocumentId: ID!
  ) {
    podcasts: podcasts_connection(
      pagination: $pagination
      filters: $filters
      sort: "publicationDate:desc"
    ) {
      nodes {
        ...PodcastBaseFragment
        listenings(
          filters: { staff: { documentId: { eq: $userDocumentId } } }
        ) {
          documentId
          listeningTime
          duration
        }
      }
      pageInfo {
        page
        pageSize
        pageCount
        total
      }
    }
  }
  ${PodcastBaseFragment}
`;

export const QUERY_PODCAST_BY_SLUG = gql`
  query podcastBySlug($slug: String!, $userDocumentId: ID!) {
    podcastBySlug(slug: $slug) {
      current {
        ...PodcastDetailFragment
        listenings(
          filters: { staff: { documentId: { eq: $userDocumentId } } }
        ) {
          documentId
          listeningTime
          duration
        }
        DefaultContentTemplate {
          ...PodcastDefaultContentTemplateFragment
        }
      }
    }
  }
  ${PodcastDetailFragment}
  ${PodcastBaseFragment}
  ${PodcastDefaultContentTemplateFragment}
`;
